// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const LogoutScopeBehaviorSchema = z.enum(['THIS_SESSION','ALL_SESSIONS','UNKNOWN'] as const);

export type LogoutScopeBehaviorType = `${z.infer<typeof LogoutScopeBehaviorSchema>}`

export default LogoutScopeBehaviorSchema;
